import AxiosPermisos from "../../axiosPermisos";

import { path } from "./path";


async function getMySecurityStatus() {
  return await AxiosPermisos.get(path.mySecurityStatus, true, "v2");
}

async function getRandomQuestion() {
  return await AxiosPermisos.get(path.randomQuestion, true, "v2");
}

async function getMyQuestions() {
  return await AxiosPermisos.get(path.myQuestions, true, "v2");
}

async function saveQuestion(data) {
  return await AxiosPermisos.post(path.saveQuestion, true, data, "v2");
}

async function validateAnswer(data) {
  return await AxiosPermisos.post(path.validateAnswer, true, data, "v2");
}

export default {
  getMySecurityStatus,
  getRandomQuestion,
  saveQuestion,
  validateAnswer,
  getMyQuestions
};
